import get from 'lodash/get';
import isObject from 'lodash/isObject';
export default (function (error) {
  return isObject(get(error, 'config')) && isObject(get(error, 'request'));
});